<template>
  <div>
    <el-dropdown :hide-on-click="false" @command="handleClick"
                 v-show="permissionCode.has('assist:task:manager')">
      <span style="font-size: 1.5em" @click="listClick">+</span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item v-if="!selectNode.data.noEdit" command="0">编辑</el-dropdown-item>
        <el-dropdown-item command="1">上方添加</el-dropdown-item>
        <el-dropdown-item command="2">下方添加</el-dropdown-item>
        <el-dropdown-item command="3">添加子任务</el-dropdown-item>
        <!--        <el-dropdown-item command="4">父菜单</el-dropdown-item>-->
        <el-dropdown-item v-if="!selectNode.data.noEdit" command="5">删除</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import {mapMutations, mapState} from "vuex";
import wikiCenter from "@/api/wikiCenter";

export default {
  name: "OptionList",
  props: {
    selectNode: {
      type: Object,
      default() {
        return {};
      },
    },
    assistRoleId: {
      type: Number,
      default() {
        return null;
      },
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState("user", ["permissionCode"])
  },
  methods: {
    ...mapMutations("taskCenter", ["showTaskEdit", "setEditNode", "setType"]),
    listClick(e) {
      e.stopPropagation();
    },
    handleClick(command) {
      switch (command) {
        case "0":
          this.setType("edit");
          break;
        case "1":
          this.setType("addBelow");
          break;
        case "2":
          this.setType("addAfter");
          break;
        case "3":
          this.setType("subMenu");
          break;
        case "4":
          this.setType("parentMenu");
          break;
        case "5":
          this.setType("delete");
          break;
        default:
          this.setType("edit");
      }
      if (command !== "5") {
        this.setEditNode(this.selectNode);
        this.showTaskEdit(true);
      } else {
        if (this.selectNode.childNodes.length > 0) {
          this.$message.warning("请先删除下级任务");
          return;
        }
        this.$confirm("请确认是否要删除当前任务", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
            .then(async () => {
              await wikiCenter.deleteAssistTask(this.selectNode.key);
              this.selectNode.remove();
            })
            .catch(() => {
            });
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
